var $ = require('../sw-jquery');
var sw = require('../../lib/sw');
var ModelScaleModal = require('./../../lib/views/ModelScaleModal');

function buildScaleModal($el) {
  var modelId = $el.data('swModelScaleModal');
  var maxBound = $el.data('swModelScaleModalMaxBound');
  var minBound = $el.data('swModelScaleModalMinBound');
  var origin = $el.data('swModelScaleOrigin');

  new ModelScaleModal({
    el: $el,
    modelId: modelId,
    minBound: minBound,
    maxBound: maxBound,
    origin: origin
  });
}

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-model-scale-modal]').each(function() {

    var $el = $(this);

    buildScaleModal($el);

  });

};

sw.on('modal-loaded', function($wrapper) {
  $wrapper.swFindWithSelf('[data-sw-model-scale-modal]').each(function() {
    var $el = $(this);

    buildScaleModal($el);
  });
});
